import { DbTimestampGenerated, DbTimestampNullable } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';
import { expectTypeOf } from 'expect-type';
import { GeneratedAlways, Insertable, Selectable, Updateable } from 'kysely';
import { z } from '@harvestiq/zod';
import { ClaimEventTypes, ClaimEventType } from './claim-event-types';
import { ClaimEventsStatuses, ClaimEventStatus } from './claim-event-statuses';

export interface ClaimEventsTable {
  id: GeneratedAlways<string>;
  claimId: string;
  status: ClaimEventStatus;
  eventType: ClaimEventType;
  createdBy: string | null;
  createdAt: DbTimestampGenerated;
  updatedAt: DbTimestampGenerated;
  deletedAt: DbTimestampNullable;
}

export type DbClaimEvent = Selectable<ClaimEventsTable>;
export type DbClaimEventInsert = Insertable<ClaimEventsTable>;
export type DbClaimEventUpdate = Updateable<ClaimEventsTable>;

export const dbClaimEventSchema = z.object({
  id: z.string().uuid(),
  claimId: z.string().uuid(),
  status: z.nativeEnum(ClaimEventsStatuses),
  eventType: z.nativeEnum(ClaimEventTypes),
  createdBy: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
});
expectTypeOf<DbClaimEvent>().toMatchTypeOf<
  z.output<typeof dbClaimEventSchema>
>();

export const dbClaimEventInsertSchema = dbClaimEventSchema
  .omit({
    id: true,
  })
  .partial()
  .extend({
    claimId: z.string().uuid(),
    status: z.nativeEnum(ClaimEventsStatuses),
    eventType: z.nativeEnum(ClaimEventTypes),
    createdAt: zTimestamp().optional(),
    updatedAt: zTimestamp().optional(),
    deletedAt: zTimestamp().nullable().optional(),
  });
type CreateClaimEventFromSchema = z.input<typeof dbClaimEventInsertSchema>;
expectTypeOf<keyof CreateClaimEventFromSchema>().toEqualTypeOf<
  keyof DbClaimEventInsert
>();
expectTypeOf<CreateClaimEventFromSchema>().toMatchTypeOf<DbClaimEventInsert>();

export const dbClaimEventUpdateSchema = dbClaimEventInsertSchema.partial();
type UpdateClaimEventFromSchema = z.input<typeof dbClaimEventUpdateSchema>;
expectTypeOf<keyof UpdateClaimEventFromSchema>().toEqualTypeOf<
  keyof DbClaimEventUpdate
>();
expectTypeOf<UpdateClaimEventFromSchema>().toMatchTypeOf<DbClaimEventUpdate>();
